<template>
	<div class="application--wrap centered-content" >
		<v-toolbar transparent :flat="true" app class="white--text">
			<v-btn icon @click="gotoWelcome">
				<v-icon color="white">arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Inloggen</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>
		<v-content>
			<v-container>
				<form class="text-xs-center" @submit.prevent="login">
					<validation-observer ref="validationObserver">
						<validation-provider name="E-mail" rules="required|email" v-slot="{ errors }" slim>
							<v-text-field
								v-model="email"
								type="email"
								:hide-details="true"
								:error-messages="errorMessages || errors[0]"
								label="E-mail"
								required box dark
								class="mb-3"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Wachtwoord" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="password"
								:error-messages="errorMessages || errors[0]"
								label="Wachtwoord"
								type="password"
								required box dark
							></v-text-field>
						</validation-provider>
					</validation-observer>
					<v-btn
						:loading="loggingIn"
						block large depressed
						color="primary"
						class="white--text mb-2"
						type="submit"
					>
						Inloggen
					</v-btn>
					<v-btn flat class="white--text" @click="gotoPasswordRecovery">
						Wachtwoord vergeten
					</v-btn>
				</form>
			</v-container>
		</v-content>
	</div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate';

  export default {
    components: { ValidationProvider, ValidationObserver },
    name: 'login-page',
    data() {
      return {
        loggingIn: false,
        email: '',
        password: '',
        errorMessages: null,
      };
    },
    methods: {
      gotoWelcome() {
        this.$router.push('/');
      },
      gotoPasswordRecovery() {
        this.$router.push('password-recovery');
      },
      async login() {
        this.loggingIn = true;
        try {
          await this.$store.dispatch('logInUser', {
            email: this.email,
            password: this.password,
          });
        } catch (e) {
          this.loggingIn = false;
          this.errorMessages = ['Ongeldig e-mailadres of wachtwoord'];
          return;
        }
        this.loggingIn = false;
        this.$router.push({ name: 'devices.index' });
      },
    },
  };
</script>

<style lang="stylus">
	.v-toolbar[transparent]
		background: transparent

	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active {
		-webkit-transition: "color 99999s ease-out, background-color 99999s ease-out";
		-webkit-transition-delay: 99999s;
	}
</style>
